import React, { Component } from 'react'
import { t } from '@lingui/macro'
import { captureException, flush } from '@sentry/browser'

import ErrorMessage from './ErrorMessage'

export interface IErrorBoundaryProps {
  message?: string
}

export interface IErrorBoundaryState {
  error?: Error
}

export default class ErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  static defaultProps = {
    message: t`Failed to load page`
  }

  state: IErrorBoundaryState = {}

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error) {
    captureException(error)

    if (error.message === 'Observable cancelled prematurely') {
      console.warn(error) // this is an annoying error getting thrown by apollo client 3.3.x. Some future versions might be okay, but it's the safest to leave this here until https://github.com/apollographql/apollo-client/issues/7608 is fixed
      // easiest to get this is to use login link on a user profile page and open it in incognito window, There it reproduces with more than 50% chance
      flush(500).then(() => {
        location.reload() // slightly hacky, but we can't think of a better hotfix ATM
      })

      return
    }
  }

  render() {
    const { children, message } = this.props
    const { error } = this.state

    if (error) {
      return <ErrorMessage error={error} message={message} />
    }

    return children
  }
}
